import thunk from 'redux-thunk'
import { configureStore } from '@reduxjs/toolkit';
import RootReducer from './reducers/RootReducer'
import { persistStore, persistReducer } from 'redux-persist';
import localforage from 'localforage';

// const initialState = {}
// const middlewares = [thunk]
// let devtools = (x) => x

// if (
//     process.env.NODE_ENV !== 'production' &&
//     process.browser &&
//     window.__REDUX_DEVTOOLS_EXTENSION__
// ) {
//     devtools = window.__REDUX_DEVTOOLS_EXTENSION__()
// }

// export const Store = createStore(
//     RootReducer,
//     initialState,
//     compose(applyMiddleware(...middlewares), devtools)
// )



const persistConfig = {
    key: 'root',
    storage: localforage,  // ✅ Ensure storage engine is correct
    version: 1,
};

const persistedReducer = persistReducer(persistConfig, RootReducer);

const Store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(thunk),
    devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(Store);

export default Store;
